import React from 'react';

import {
	styled
} from 'ps-gui';
import { getFormItemLabel } from '../../data/phrases';

/*
	fullButtonBorder: '2px solid #4FC098',
	fullButtonFontSize: '16px',
	fullButtonFontWeight: '500',
	fullButtonBackground: '#4FC098',

	mediumButtonBorder: '1px solid #4FC098',
	mediumButtonColor: '#4FC098',
	mediumButtonBackground: 'none',
*/

const Button = styled.div`
	font-size: 12px;
	font-weight: 500;
	display: inline-block;
	padding: 2px 6px;
	border-radius: ${props => props.theme.fullButtonBorderRadius};
	border: ${props => props.theme.mediumButtonBorder};
	color: ${props => props.theme.mediumButtonColor};
	background: ${props => props.theme.mediumButtonBackground};

	&[data-hasvalue] {
		color: ${props => props.theme.fullButtonColor};
		background: ${props => props.theme.fullButtonBackground};
	}

	&[hidden] {
		visibility: hidden;
	}

`;

const Wrapper = styled.div`
	padding-top: 6px;
	height: 35px;
	&[readOnly] {
		background: ${props => props.theme.inputReadOnlyBackground};
		${Button} {
			opacity: 0.4;
		}
	}
	&:not([readOnly]) {
		${Button} {
			cursor: pointer;
			&:hover {
				text-decoration: underline;
			}
		}
	}
`;


export default class CorrectionInput extends React.PureComponent {
	render() {
		return (
			<Wrapper readOnly={this.props.readOnly}>
				<Button
					hidden={this.props.noButton}
					data-hasvalue={!!this.props.value || null}
					title={this.props.value}
					onMouseDown={e => {
						if (!this.props.readOnly) {
							this.props.onMouseDown(e);
						}
					}}
				>
					{this.props.text || getFormItemLabel('correction')}
				</Button>
			</Wrapper>
		);
	}
}

export class Bubble extends React.Component {
	render() {
		return (
			<Wrapper readOnly={this.props.readOnly}>
				<Button
					hidden={this.props.noButton}
					data-hasvalue={!!this.props.value || null}
					title={this.props.value}
					onMouseDown={this.props.onMouseDown}
				>
					{this.props.text}
				</Button>
			</Wrapper>
		);
	}
}
